export default "__VITE_ASSET__DV$eIoaO__"